import { TypedDocumentNode, gql } from '@apollo/client';

type getPendingCompanyUsersByIdQueryVariables = { company_id?: number };

export type PendingCompanyUser = {
  id: string;
  invitation_sent_at: string;
  email: string;
  identity_verified: boolean;
};

type getPendingCompanyUsersByIdQueryType = {
  orders_companies_by_pk: {
    company_users: Array<PendingCompanyUser>;
  };
};
export const getPendingCompanyUsersByIdQuery = gql`
  query getPendingUsers($company_id: bigint!) {
    orders_companies_by_pk(id: $company_id) {
      company_users(
        where: {
          _and: {
            invitation_accepted_at: { _is_null: true }
            is_active: { _eq: true }
          }
        }
      ) {
        id
        invitation_sent_at
        email
        identity_verified
      }
    }
  }
` as TypedDocumentNode<
  getPendingCompanyUsersByIdQueryType,
  getPendingCompanyUsersByIdQueryVariables
>;
